<div class="flex my-6 items-center justify-center gap-6 flex-wrap">
  @for (item of formArray.controls; track $index) {
  <div
    class="clickable-card flex flex-col content-center items-center cursor-pointer w-1/3 min-w-[310px]"
    (click)="handleClickFromButtons(item.controls.id.value)"
    (keydown)="handleClickFromButtons(item.controls.id.value)"
    [ngClass]="setClassActive(item.controls.isSelected.value)">
    <div [class]="item.controls.classIcon.value"></div>
    <div class="flex flex-row items-center pb-8 place-content-between">
      <p class="mr-2">{{ item.controls!.label.value }}</p>
    </div>
  </div>
  }
</div>

<app-web-callback-popup
  [show]="displayModal"
  (cancel)="displayModal = false"></app-web-callback-popup>
